import { useEffect, useState } from 'react'

import EditContextProvider from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import Search from 'Components/UI/Atoms/Search'
import ListWithIcon from 'Components/UI/Molecules/Lists/ListWithIcon'
import PaperList from 'Components/UI/Molecules/Papers/PaperList'
import { interfaces } from 'service/interfaces'

import DialogEdit from './Update'

const WafersContent = () => {
  const [concepts, setConcepts] = useState([])
  const [valueSearch, setValueSearch] = useState('')
  const [selectedConcept, setSelectedConcept] = useState(null)
  const [render, setRender] = useState(false)
  const [tipoOblea, setTipoOblea] = useState()
  const [constants, setConstants] = useState()
  const [vehicleTypes, setVehicleTypes] = useState([])

  const { state: editConcept, setOpen: setOpenEdit, setClose: setCloseEdit } = SetState()

  const getConcepts = async () => {
    await Promise.all([interfaces.configInterface.listWafers(), interfaces.interfaceTypeVehicle.list()])
      .then(([wafersRes, vehicleTypesRes]) => {
        setConcepts(wafersRes.data.wafers)
        setTipoOblea(wafersRes.data.OBLEA_TIPO)
        setVehicleTypes(vehicleTypesRes.data.vehicleTypes || [])
        setConstants({
          puertas: wafersRes.data.PUERTAS,
          tracciones: wafersRes.data.TRACCIONES,
          transmisiones: wafersRes.data.TRANSMISIONES,
          combustibles: wafersRes.data.COMBUSTIBLES,
          turbos: wafersRes.data.TURBOS,
        })
      })
      .catch((err) => {
        console.error('Error listando obleas:', err)
      })
  }

  const onChangeSearch = (e) => {
    setValueSearch(e.target.value.toLowerCase())
  }

  const search = (data) => {
    return data
      .filter((wafer) => {
        return wafer.oblea_rudac.toLowerCase().includes(valueSearch)
      })
      .sort((a, b) => a.oblea_rudac.localeCompare(b.oblea_rudac, 'es', { sensitivity: 'base' }))
  }

  const onClickItem = (item) => {
    setSelectedConcept(item)
  }

  useEffect(() => {
    getConcepts()
  }, [render])

  return (
    <>
      <Search onChange={onChangeSearch} placeholder="Buscar" />
      <PaperList
        children={
          <ListWithIcon
            data={search(concepts)}
            nameIncludes="oblea_rudac"
            selectedItem={selectedConcept?.id}
            onClickSelect={onClickItem}
            onClickEdit={setOpenEdit}
          />
        }
        height="500px"
        styles={{ marginBottom: '15px' }}
      />

      <EditContextProvider>
        <DialogEdit
          open={editConcept.open}
          selectedConcept={selectedConcept}
          handleClose={setCloseEdit}
          setSelectedConcept={setSelectedConcept}
          tipoOblea={tipoOblea}
          vehicleTypes={vehicleTypes}
          constants={constants}
          setRender={setRender}
          render={render}
        />
      </EditContextProvider>
    </>
  )
}

export default WafersContent
